module.exports = __webpack_public_path__ + "img/38_15.15a72fe4.png";